import { Helmet } from 'react-helmet-async';

export default function SchemaMarkup({ type, data }) {
  const domain = "https://mupax.eu";
  const logoUrl = `${domain}/logo.svg`; // Eeldame, et logo.svg on public kaustas

  // Baasandmed organisatsiooni kohta
  const organizationSchema = {
    "@type": "Organization",
    "name": "Mupax OÜ",
    "url": domain,
    "logo": logoUrl,
    "sameAs": [
      "https://www.linkedin.com/company/mupax-oy"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "info@mupax.eu",
      "contactType": "customer service",
      "areaServed": ["EE", "EU"],
      "availableLanguage": ["Estonian", "English"]
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Tallinn",
      "addressCountry": "EE"
    }
  };

  let schema = null;

  // URL-i loogika (kui data.url on olemas, kasutame seda, muidu domeeni)
  const currentUrl = data?.url ? `${domain}${data.url}` : domain;

  switch (type) {
    case 'organization':
      schema = {
        "@context": "https://schema.org",
        ...organizationSchema
      };
      break;

    case 'about-page':
      schema = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": data.title,
        "description": data.description,
        "url": currentUrl,
        "mainEntity": organizationSchema
      };
      break;

    case 'contact-page':
      schema = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": data.title,
        "description": data.description,
        "url": currentUrl,
        "mainEntity": organizationSchema
      };
      break;

    case 'blog':
      // Blogi indeksleht
      schema = {
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "Mupax Engineering Blog",
        "description": data.description,
        "url": currentUrl,
        "publisher": organizationSchema
      };
      break;

    case 'collection':
      // Portfoolio indeksleht
      schema = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "name": data.title,
        "description": data.description,
        "url": currentUrl
      };
      break;

    case 'webpage':
      // Üldine leht (Privacy, Terms jne)
      schema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": data.title,
        "description": data.description,
        "url": currentUrl,
        "publisher": organizationSchema
      };
      break;

    case 'article':
      // Blogipostitus
      schema = {
        "@context": "https://schema.org",
        "@type": "TechArticle",
        "headline": data.title,
        "description": data.description,
        "image": data.image ? `${domain}${data.image}` : `${domain}/og-image.jpg`,
        "datePublished": data.date,
        "dateModified": data.updated || data.date,
        "inLanguage": "en",
        "keywords": (data.tags || []).join(", "),
        "articleSection": data.tags?.[0],
        "author": {
          "@type": "Person",
          "name": "Jaanek Liiskmaa",
          "jobTitle": "Asutaja & juhtivinsener",
          "url": `${domain}/et/about`,
          "worksFor": { "@type": "Organization", "name": "Mupax OÜ" }
        },
        "publisher": organizationSchema,
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": currentUrl
        }
      };
      break;
      
    case 'service':
       // Teenused
       schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": data.name,
        "provider": organizationSchema,
        "description": data.description
      };
      break;

    case 'local-business':
      schema = {
        "@context": "https://schema.org",
        "@type": ["LocalBusiness", "ProfessionalService"],
        "name": "Mupax OÜ",
        "url": domain,
        "logo": logoUrl,
        "image": `${domain}/og-image.jpg`,
        "description": "Veebiarendus, e-poe tegemine ja tarkvaralahendused Eesti ettevõtetele.",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Tallinn",
          "addressRegion": "Harjumaa",
          "addressCountry": "EE"
        },
        "areaServed": {
          "@type": "Country",
          "name": "Estonia"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "email": "info@mupax.eu",
          "contactType": "customer service",
          "availableLanguage": ["Estonian", "English"]
        },
        "sameAs": [
          "https://www.linkedin.com/company/mupax-oy"
        ],
        "priceRange": "€€"
      };
      break;

    case 'case-study':
      // Üksik portfoolio projekt
      schema = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": data.title,
        "description": data.summary,
        "genre": "Case Study",
        "author": organizationSchema,
        "publisher": organizationSchema,
        "keywords": (data.tags || []).join(", "),
        "about": (data.tags || []).map((tag) => ({ "@type": "Thing", "name": tag })),
        "inLanguage": data.url && data.url.startsWith('/et') ? "et" : "en",
        "mainEntityOfPage": { "@type": "WebPage", "@id": currentUrl }
      };
      break;

    default:
      return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
